import React from 'react';
import { STRINGS } from 'config';
import request from 'superagent';
import { toast } from '@econsult/econsult-ui/dist/components/Toast';
import { ErrorToast, SuccessToast } from 'components/Toast';

const { API: { PRACTICE_URL } } = STRINGS;

export const getErrorMessage = (method, error) => (
  `Unable to ${method} custom landing page message. Please ${error.status === 401 ? 'refresh the page and ' : ''}try again.`
);

export const handleError = method => error => {
  const toastText = getErrorMessage(method, error);
  toast.error(<ErrorToast message={toastText} />, { id: false, autoClose: 12_000, icon: false });
  return false;
};

export const getCustomLandingPageMessage = practiceId => (
  request
    .get(`${PRACTICE_URL}/${practiceId}/custom-landing-page-message`)
    .withCredentials()
    .retry(3)
    .then(response => ({
      message: response.body.message?.replace(/<[^>]*>/g, '') || '',
      showMessage: response.body.showMessage || false,
    }))
    .catch(handleError('get'))
);

export const saveCustomLandingPageMessageAndVisibility = ({ practiceId, message, showMessage }) => (
  request
    .post(`${PRACTICE_URL}/${practiceId}/custom-landing-page-message`)
    .withCredentials()
    .retry(3)
    .send({ showMessage, message })
    .then(() => {
      toast(<SuccessToast message="Custom landing page message saved successfully" />);
      return true;
    })
    .catch(handleError('save'))
);
